import { MdMoneyOff } from "react-icons/md";
import { toCurrencyFormat } from "helpers/utils";
import paymentsService from "services/admin/paymentsService";
import { useDashboardQuery } from "../dashboard-utils";
import KpiCard from "./KpiCard";

const RefundTotalAmount = ({ month }) => {
  const q = useDashboardQuery(["refund-total", month], async () => (await paymentsService.getRefundTotalAmount({ month })).data);

  return (
    <KpiCard
      icon={MdMoneyOff}
      accent="red"
      label="Возвраты"
      hint="Сумма возвратов за выбранный период"
      to="/admin/sub-orders/payments"
      value={toCurrencyFormat(q.data?.sum, q.data?.currency)}
      loading={q.isLoading}
      fetching={q.isPlaceholderData}
      error={q.error}
      onRetry={q.refetch}
    />
  );
};

export default RefundTotalAmount;
